<div class="ttmodal" *ngIf="sendEmail==true">
  <div class="ttmodal__header">
      <span class="ttmodal__title">{{'Send Training' | translate | async}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput" >
          <span class="label">{{'Select Users' | translate | async}} <span class="red-text"></span></span>
          
          <!-- <span style="font-size: larger; "><b>Filter by User</b></span> -->
          <mat-select placeholder="Select User" style="width: 345px;     margin-left: 2%;" [(ngModel)]="UserId" multiple>
            <mat-option *ngFor="let user of UserList" [value]="user.Id" (click)="SelectUser()" >
              {{user.Name | aesDecrypt}}
            </mat-option>
          </mat-select>
      </div>
     
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">{{'Cancel' | translate | async}}</span></a>
      <a class="button button--primary" (click)="onSendEmail()"><span class="button__text">{{'Send Email' | translate | async}}</span></a>
  </div>
</div>

<div class="ttmodal" *ngIf="warning==true">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Warning</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput" >
          <span class="label">{{'Would you like to do the course again?' | translate | async}}  <span class="red-text"></span></span>
          
      </div>
     
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">No</span></a>
      <a class="button button--primary" (click)="OpenTraining()"><span class="button__text">Yes</span></a>
  </div>
</div>